import { createAction } from '@reduxjs/toolkit';
import { AcceptedPageData, PendingList } from '../types';
import requestPageConstants from './constant';

export const storePageRequestList = createAction<AcceptedPageData[]>(requestPageConstants.STORE_REQUEST_LIST);
export const storePendingPageList = createAction<PendingList[]>(requestPageConstants.STORE_PENDING_REQUEST_LIST);
